import { useContext as yt, useMemo as or, createContext as bt } from "react";
import { jsx as ur } from "react/jsx-runtime";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var u = function() {
  return u = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, u.apply(this, arguments);
};
function fr(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function cr(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), a, i = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function $() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(cr(arguments[t]));
  return e;
}
function pr() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function ve() {
  return !pr() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function lr(e, t) {
  return e.require(t);
}
var hr = {};
function m() {
  return ve() ? global : typeof window < "u" ? window : typeof self < "u" ? self : hr;
}
function ge(e, t, r) {
  var n = r || m(), a = n.__SENTRY__ = n.__SENTRY__ || {}, i = a[e] || (a[e] = t());
  return i;
}
var _r = Object.prototype.toString;
function dr(e, t) {
  return _r.call(e) === "[object " + t + "]";
}
function $t(e) {
  return dr(e, "Object");
}
function St(e) {
  return Boolean(e && e.then && typeof e.then == "function");
}
var mt = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, vr = m(), gr = "Sentry Logger ", se = ["debug", "info", "warn", "error", "log", "assert"];
function xt(e) {
  var t = m();
  if (!("console" in t))
    return e();
  var r = t.console, n = {};
  se.forEach(function(a) {
    var i = r[a] && r[a].__sentry_original__;
    a in t.console && i && (n[a] = r[a], r[a] = i);
  });
  try {
    return e();
  } finally {
    Object.keys(n).forEach(function(a) {
      r[a] = n[a];
    });
  }
}
function Ie() {
  var e = !1, t = {
    enable: function() {
      e = !0;
    },
    disable: function() {
      e = !1;
    }
  };
  return mt ? se.forEach(function(r) {
    t[r] = function() {
      for (var n = [], a = 0; a < arguments.length; a++)
        n[a] = arguments[a];
      e && xt(function() {
        var i;
        (i = vr.console)[r].apply(i, $([gr + "[" + r + "]:"], n));
      });
    };
  }) : se.forEach(function(r) {
    t[r] = function() {
    };
  }), t;
}
var F;
mt ? F = ge("logger", Ie) : F = Ie();
function oe(e) {
  var t, r;
  if ($t(e)) {
    var n = {};
    try {
      for (var a = fr(Object.keys(e)), i = a.next(); !i.done; i = a.next()) {
        var s = i.value;
        typeof e[s] < "u" && (n[s] = oe(e[s]));
      }
    } catch (o) {
      t = { error: o };
    } finally {
      try {
        i && !i.done && (r = a.return) && r.call(a);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return n;
  }
  return Array.isArray(e) ? e.map(oe) : e;
}
function j() {
  var e = m(), t = e.crypto || e.msCrypto;
  if (t !== void 0 && t.getRandomValues) {
    var r = new Uint16Array(8);
    t.getRandomValues(r), r[3] = r[3] & 4095 | 16384, r[4] = r[4] & 16383 | 32768;
    var n = function(a) {
      for (var i = a.toString(16); i.length < 4; )
        i = "0" + i;
      return i;
    };
    return n(r[0]) + n(r[1]) + n(r[2]) + n(r[3]) + n(r[4]) + n(r[5]) + n(r[6]) + n(r[7]);
  }
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(a) {
    var i = Math.random() * 16 | 0, s = a === "x" ? i : i & 3 | 8;
    return s.toString(16);
  });
}
var yr = function() {
  function e(t) {
    var r = this;
    this._state = 0, this._handlers = [], this._resolve = function(n) {
      r._setResult(1, n);
    }, this._reject = function(n) {
      r._setResult(2, n);
    }, this._setResult = function(n, a) {
      if (r._state === 0) {
        if (St(a)) {
          a.then(r._resolve, r._reject);
          return;
        }
        r._state = n, r._value = a, r._executeHandlers();
      }
    }, this._executeHandlers = function() {
      if (r._state !== 0) {
        var n = r._handlers.slice();
        r._handlers = [], n.forEach(function(a) {
          a[0] || (r._state === 1 && a[1](r._value), r._state === 2 && a[2](r._value), a[0] = !0);
        });
      }
    };
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  return e.prototype.then = function(t, r) {
    var n = this;
    return new e(function(a, i) {
      n._handlers.push([
        !1,
        function(s) {
          if (!t)
            a(s);
          else
            try {
              a(t(s));
            } catch (o) {
              i(o);
            }
        },
        function(s) {
          if (!r)
            i(s);
          else
            try {
              a(r(s));
            } catch (o) {
              i(o);
            }
        }
      ]), n._executeHandlers();
    });
  }, e.prototype.catch = function(t) {
    return this.then(function(r) {
      return r;
    }, t);
  }, e.prototype.finally = function(t) {
    var r = this;
    return new e(function(n, a) {
      var i, s;
      return r.then(function(o) {
        s = !1, i = o, t && t();
      }, function(o) {
        s = !0, i = o, t && t();
      }).then(function() {
        if (s) {
          a(i);
          return;
        }
        n(i);
      });
    });
  }, e;
}(), ue = {
  nowSeconds: function() {
    return Date.now() / 1e3;
  }
};
function br() {
  var e = m().performance;
  if (!(!e || !e.now)) {
    var t = Date.now() - e.now();
    return {
      now: function() {
        return e.now();
      },
      timeOrigin: t
    };
  }
}
function $r() {
  try {
    var e = lr(module, "perf_hooks");
    return e.performance;
  } catch {
    return;
  }
}
var Q = ve() ? $r() : br(), Re = Q === void 0 ? ue : {
  nowSeconds: function() {
    return (Q.timeOrigin + Q.now()) / 1e3;
  }
}, At = ue.nowSeconds.bind(ue), Le = Re.nowSeconds.bind(Re);
(function() {
  var e = m().performance;
  if (!(!e || !e.now)) {
    var t = 3600 * 1e3, r = e.now(), n = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - n) : t, i = a < t, s = e.timing && e.timing.navigationStart, o = typeof s == "number", f = o ? Math.abs(s + r - n) : t, c = f < t;
    return i || c ? a <= f ? e.timeOrigin : s : n;
  }
})();
var Me = 100, fe = function() {
  function e() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  return e.clone = function(t) {
    var r = new e();
    return t && (r._breadcrumbs = $(t._breadcrumbs), r._tags = u({}, t._tags), r._extra = u({}, t._extra), r._contexts = u({}, t._contexts), r._user = t._user, r._level = t._level, r._span = t._span, r._session = t._session, r._transactionName = t._transactionName, r._fingerprint = t._fingerprint, r._eventProcessors = $(t._eventProcessors), r._requestSession = t._requestSession), r;
  }, e.prototype.addScopeListener = function(t) {
    this._scopeListeners.push(t);
  }, e.prototype.addEventProcessor = function(t) {
    return this._eventProcessors.push(t), this;
  }, e.prototype.setUser = function(t) {
    return this._user = t || {}, this._session && this._session.update({ user: t }), this._notifyScopeListeners(), this;
  }, e.prototype.getUser = function() {
    return this._user;
  }, e.prototype.getRequestSession = function() {
    return this._requestSession;
  }, e.prototype.setRequestSession = function(t) {
    return this._requestSession = t, this;
  }, e.prototype.setTags = function(t) {
    return this._tags = u(u({}, this._tags), t), this._notifyScopeListeners(), this;
  }, e.prototype.setTag = function(t, r) {
    var n;
    return this._tags = u(u({}, this._tags), (n = {}, n[t] = r, n)), this._notifyScopeListeners(), this;
  }, e.prototype.setExtras = function(t) {
    return this._extra = u(u({}, this._extra), t), this._notifyScopeListeners(), this;
  }, e.prototype.setExtra = function(t, r) {
    var n;
    return this._extra = u(u({}, this._extra), (n = {}, n[t] = r, n)), this._notifyScopeListeners(), this;
  }, e.prototype.setFingerprint = function(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }, e.prototype.setLevel = function(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }, e.prototype.setTransactionName = function(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }, e.prototype.setTransaction = function(t) {
    return this.setTransactionName(t);
  }, e.prototype.setContext = function(t, r) {
    var n;
    return r === null ? delete this._contexts[t] : this._contexts = u(u({}, this._contexts), (n = {}, n[t] = r, n)), this._notifyScopeListeners(), this;
  }, e.prototype.setSpan = function(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }, e.prototype.getSpan = function() {
    return this._span;
  }, e.prototype.getTransaction = function() {
    var t = this.getSpan();
    return t && t.transaction;
  }, e.prototype.setSession = function(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }, e.prototype.getSession = function() {
    return this._session;
  }, e.prototype.update = function(t) {
    if (!t)
      return this;
    if (typeof t == "function") {
      var r = t(this);
      return r instanceof e ? r : this;
    }
    return t instanceof e ? (this._tags = u(u({}, this._tags), t._tags), this._extra = u(u({}, this._extra), t._extra), this._contexts = u(u({}, this._contexts), t._contexts), t._user && Object.keys(t._user).length && (this._user = t._user), t._level && (this._level = t._level), t._fingerprint && (this._fingerprint = t._fingerprint), t._requestSession && (this._requestSession = t._requestSession)) : $t(t) && (t = t, this._tags = u(u({}, this._tags), t.tags), this._extra = u(u({}, this._extra), t.extra), this._contexts = u(u({}, this._contexts), t.contexts), t.user && (this._user = t.user), t.level && (this._level = t.level), t.fingerprint && (this._fingerprint = t.fingerprint), t.requestSession && (this._requestSession = t.requestSession)), this;
  }, e.prototype.clear = function() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this;
  }, e.prototype.addBreadcrumb = function(t, r) {
    var n = typeof r == "number" ? Math.min(r, Me) : Me;
    if (n <= 0)
      return this;
    var a = u({ timestamp: At() }, t);
    return this._breadcrumbs = $(this._breadcrumbs, [a]).slice(-n), this._notifyScopeListeners(), this;
  }, e.prototype.clearBreadcrumbs = function() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }, e.prototype.applyToEvent = function(t, r) {
    if (this._extra && Object.keys(this._extra).length && (t.extra = u(u({}, this._extra), t.extra)), this._tags && Object.keys(this._tags).length && (t.tags = u(u({}, this._tags), t.tags)), this._user && Object.keys(this._user).length && (t.user = u(u({}, this._user), t.user)), this._contexts && Object.keys(this._contexts).length && (t.contexts = u(u({}, this._contexts), t.contexts)), this._level && (t.level = this._level), this._transactionName && (t.transaction = this._transactionName), this._span) {
      t.contexts = u({ trace: this._span.getTraceContext() }, t.contexts);
      var n = this._span.transaction && this._span.transaction.name;
      n && (t.tags = u({ transaction: n }, t.tags));
    }
    return this._applyFingerprint(t), t.breadcrumbs = $(t.breadcrumbs || [], this._breadcrumbs), t.breadcrumbs = t.breadcrumbs.length > 0 ? t.breadcrumbs : void 0, t.sdkProcessingMetadata = this._sdkProcessingMetadata, this._notifyEventProcessors($(Sr(), this._eventProcessors), t, r);
  }, e.prototype.setSDKProcessingMetadata = function(t) {
    return this._sdkProcessingMetadata = u(u({}, this._sdkProcessingMetadata), t), this;
  }, e.prototype._notifyEventProcessors = function(t, r, n, a) {
    var i = this;
    return a === void 0 && (a = 0), new yr(function(s, o) {
      var f = t[a];
      if (r === null || typeof f != "function")
        s(r);
      else {
        var c = f(u({}, r), n);
        St(c) ? c.then(function(p) {
          return i._notifyEventProcessors(t, p, n, a + 1).then(s);
        }).then(null, o) : i._notifyEventProcessors(t, c, n, a + 1).then(s).then(null, o);
      }
    });
  }, e.prototype._notifyScopeListeners = function() {
    var t = this;
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function(r) {
      r(t);
    }), this._notifyingListeners = !1);
  }, e.prototype._applyFingerprint = function(t) {
    t.fingerprint = t.fingerprint ? Array.isArray(t.fingerprint) ? t.fingerprint : [t.fingerprint] : [], this._fingerprint && (t.fingerprint = t.fingerprint.concat(this._fingerprint)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
  }, e;
}();
function Sr() {
  return ge("globalEventProcessors", function() {
    return [];
  });
}
var mr = function() {
  function e(t) {
    this.errors = 0, this.sid = j(), this.duration = 0, this.status = "ok", this.init = !0, this.ignoreDuration = !1;
    var r = Le();
    this.timestamp = r, this.started = r, t && this.update(t);
  }
  return e.prototype.update = function(t) {
    if (t === void 0 && (t = {}), t.user && (!this.ipAddress && t.user.ip_address && (this.ipAddress = t.user.ip_address), !this.did && !t.did && (this.did = t.user.id || t.user.email || t.user.username)), this.timestamp = t.timestamp || Le(), t.ignoreDuration && (this.ignoreDuration = t.ignoreDuration), t.sid && (this.sid = t.sid.length === 32 ? t.sid : j()), t.init !== void 0 && (this.init = t.init), !this.did && t.did && (this.did = "" + t.did), typeof t.started == "number" && (this.started = t.started), this.ignoreDuration)
      this.duration = void 0;
    else if (typeof t.duration == "number")
      this.duration = t.duration;
    else {
      var r = this.timestamp - this.started;
      this.duration = r >= 0 ? r : 0;
    }
    t.release && (this.release = t.release), t.environment && (this.environment = t.environment), !this.ipAddress && t.ipAddress && (this.ipAddress = t.ipAddress), !this.userAgent && t.userAgent && (this.userAgent = t.userAgent), typeof t.errors == "number" && (this.errors = t.errors), t.status && (this.status = t.status);
  }, e.prototype.close = function(t) {
    t ? this.update({ status: t }) : this.status === "ok" ? this.update({ status: "exited" }) : this.update();
  }, e.prototype.toJSON = function() {
    return oe({
      sid: "" + this.sid,
      init: this.init,
      started: new Date(this.started * 1e3).toISOString(),
      timestamp: new Date(this.timestamp * 1e3).toISOString(),
      status: this.status,
      errors: this.errors,
      did: typeof this.did == "number" || typeof this.did == "string" ? "" + this.did : void 0,
      duration: this.duration,
      attrs: {
        release: this.release,
        environment: this.environment,
        ip_address: this.ipAddress,
        user_agent: this.userAgent
      }
    });
  }, e;
}(), De = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, ye = 4, xr = 100, be = function() {
  function e(t, r, n) {
    r === void 0 && (r = new fe()), n === void 0 && (n = ye), this._version = n, this._stack = [{}], this.getStackTop().scope = r, t && this.bindClient(t);
  }
  return e.prototype.isOlderThan = function(t) {
    return this._version < t;
  }, e.prototype.bindClient = function(t) {
    var r = this.getStackTop();
    r.client = t, t && t.setupIntegrations && t.setupIntegrations();
  }, e.prototype.pushScope = function() {
    var t = fe.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: t
    }), t;
  }, e.prototype.popScope = function() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }, e.prototype.withScope = function(t) {
    var r = this.pushScope();
    try {
      t(r);
    } finally {
      this.popScope();
    }
  }, e.prototype.getClient = function() {
    return this.getStackTop().client;
  }, e.prototype.getScope = function() {
    return this.getStackTop().scope;
  }, e.prototype.getStack = function() {
    return this._stack;
  }, e.prototype.getStackTop = function() {
    return this._stack[this._stack.length - 1];
  }, e.prototype.captureException = function(t, r) {
    var n = this._lastEventId = r && r.event_id ? r.event_id : j(), a = r;
    if (!r) {
      var i = void 0;
      try {
        throw new Error("Sentry syntheticException");
      } catch (s) {
        i = s;
      }
      a = {
        originalException: t,
        syntheticException: i
      };
    }
    return this._invokeClient("captureException", t, u(u({}, a), { event_id: n })), n;
  }, e.prototype.captureMessage = function(t, r, n) {
    var a = this._lastEventId = n && n.event_id ? n.event_id : j(), i = n;
    if (!n) {
      var s = void 0;
      try {
        throw new Error(t);
      } catch (o) {
        s = o;
      }
      i = {
        originalException: t,
        syntheticException: s
      };
    }
    return this._invokeClient("captureMessage", t, r, u(u({}, i), { event_id: a })), a;
  }, e.prototype.captureEvent = function(t, r) {
    var n = r && r.event_id ? r.event_id : j();
    return t.type !== "transaction" && (this._lastEventId = n), this._invokeClient("captureEvent", t, u(u({}, r), { event_id: n })), n;
  }, e.prototype.lastEventId = function() {
    return this._lastEventId;
  }, e.prototype.addBreadcrumb = function(t, r) {
    var n = this.getStackTop(), a = n.scope, i = n.client;
    if (!(!a || !i)) {
      var s = i.getOptions && i.getOptions() || {}, o = s.beforeBreadcrumb, f = o === void 0 ? null : o, c = s.maxBreadcrumbs, p = c === void 0 ? xr : c;
      if (!(p <= 0)) {
        var l = At(), h = u({ timestamp: l }, t), d = f ? xt(function() {
          return f(h, r);
        }) : h;
        d !== null && a.addBreadcrumb(d, p);
      }
    }
  }, e.prototype.setUser = function(t) {
    var r = this.getScope();
    r && r.setUser(t);
  }, e.prototype.setTags = function(t) {
    var r = this.getScope();
    r && r.setTags(t);
  }, e.prototype.setExtras = function(t) {
    var r = this.getScope();
    r && r.setExtras(t);
  }, e.prototype.setTag = function(t, r) {
    var n = this.getScope();
    n && n.setTag(t, r);
  }, e.prototype.setExtra = function(t, r) {
    var n = this.getScope();
    n && n.setExtra(t, r);
  }, e.prototype.setContext = function(t, r) {
    var n = this.getScope();
    n && n.setContext(t, r);
  }, e.prototype.configureScope = function(t) {
    var r = this.getStackTop(), n = r.scope, a = r.client;
    n && a && t(n);
  }, e.prototype.run = function(t) {
    var r = je(this);
    try {
      t(this);
    } finally {
      je(r);
    }
  }, e.prototype.getIntegration = function(t) {
    var r = this.getClient();
    if (!r)
      return null;
    try {
      return r.getIntegration(t);
    } catch {
      return De && F.warn("Cannot retrieve integration " + t.id + " from the current Hub"), null;
    }
  }, e.prototype.startSpan = function(t) {
    return this._callExtensionMethod("startSpan", t);
  }, e.prototype.startTransaction = function(t, r) {
    return this._callExtensionMethod("startTransaction", t, r);
  }, e.prototype.traceHeaders = function() {
    return this._callExtensionMethod("traceHeaders");
  }, e.prototype.captureSession = function(t) {
    if (t === void 0 && (t = !1), t)
      return this.endSession();
    this._sendSessionUpdate();
  }, e.prototype.endSession = function() {
    var t = this.getStackTop(), r = t && t.scope, n = r && r.getSession();
    n && n.close(), this._sendSessionUpdate(), r && r.setSession();
  }, e.prototype.startSession = function(t) {
    var r = this.getStackTop(), n = r.scope, a = r.client, i = a && a.getOptions() || {}, s = i.release, o = i.environment, f = m(), c = (f.navigator || {}).userAgent, p = new mr(u(u(u({
      release: s,
      environment: o
    }, n && { user: n.getUser() }), c && { userAgent: c }), t));
    if (n) {
      var l = n.getSession && n.getSession();
      l && l.status === "ok" && l.update({ status: "exited" }), this.endSession(), n.setSession(p);
    }
    return p;
  }, e.prototype._sendSessionUpdate = function() {
    var t = this.getStackTop(), r = t.scope, n = t.client;
    if (!!r) {
      var a = r.getSession && r.getSession();
      a && n && n.captureSession && n.captureSession(a);
    }
  }, e.prototype._invokeClient = function(t) {
    for (var r, n = [], a = 1; a < arguments.length; a++)
      n[a - 1] = arguments[a];
    var i = this.getStackTop(), s = i.scope, o = i.client;
    o && o[t] && (r = o)[t].apply(r, $(n, [s]));
  }, e.prototype._callExtensionMethod = function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    var a = z(), i = a.__SENTRY__;
    if (i && i.extensions && typeof i.extensions[t] == "function")
      return i.extensions[t].apply(this, r);
    De && F.warn("Extension method " + t + " couldn't be found, doing nothing.");
  }, e;
}();
function z() {
  var e = m();
  return e.__SENTRY__ = e.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, e;
}
function je(e) {
  var t = z(), r = S(t);
  return $e(t, e), r;
}
function Ar() {
  var e = z();
  return (!Tt(e) || S(e).isOlderThan(ye)) && $e(e, new be()), ve() ? Tr(e) : S(e);
}
function Tr(e) {
  try {
    var t = z().__SENTRY__, r = t && t.extensions && t.extensions.domain && t.extensions.domain.active;
    if (!r)
      return S(e);
    if (!Tt(r) || S(r).isOlderThan(ye)) {
      var n = S(e).getStackTop();
      $e(r, new be(n.client, fe.clone(n.scope)));
    }
    return S(r);
  } catch {
    return S(e);
  }
}
function Tt(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function S(e) {
  return ge("hub", function() {
    return new be();
  }, e);
}
function $e(e, t) {
  if (!e)
    return !1;
  var r = e.__SENTRY__ = e.__SENTRY__ || {};
  return r.hub = t, !0;
}
function Et(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = Ar();
  if (n && n[e])
    return n[e].apply(n, $(t));
  throw new Error("No hub defined or " + e + " was not found on the hub, please open a bug report.");
}
function ee(e, t) {
  var r = new Error("Sentry syntheticException");
  return Et("captureException", e, {
    captureContext: t,
    originalException: e,
    syntheticException: r
  });
}
function te(e) {
  Et("withScope", e);
}
var H = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Er(e, t, r, n) {
  var a = -1, i = e == null ? 0 : e.length;
  for (n && i && (r = e[++a]); ++a < i; )
    r = t(r, e[a], a, e);
  return r;
}
var Or = Er;
function wr(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Pr = wr, Cr = Pr, Ir = {
  \u00C0: "A",
  \u00C1: "A",
  \u00C2: "A",
  \u00C3: "A",
  \u00C4: "A",
  \u00C5: "A",
  \u00E0: "a",
  \u00E1: "a",
  \u00E2: "a",
  \u00E3: "a",
  \u00E4: "a",
  \u00E5: "a",
  \u00C7: "C",
  \u00E7: "c",
  \u00D0: "D",
  \u00F0: "d",
  \u00C8: "E",
  \u00C9: "E",
  \u00CA: "E",
  \u00CB: "E",
  \u00E8: "e",
  \u00E9: "e",
  \u00EA: "e",
  \u00EB: "e",
  \u00CC: "I",
  \u00CD: "I",
  \u00CE: "I",
  \u00CF: "I",
  \u00EC: "i",
  \u00ED: "i",
  \u00EE: "i",
  \u00EF: "i",
  \u00D1: "N",
  \u00F1: "n",
  \u00D2: "O",
  \u00D3: "O",
  \u00D4: "O",
  \u00D5: "O",
  \u00D6: "O",
  \u00D8: "O",
  \u00F2: "o",
  \u00F3: "o",
  \u00F4: "o",
  \u00F5: "o",
  \u00F6: "o",
  \u00F8: "o",
  \u00D9: "U",
  \u00DA: "U",
  \u00DB: "U",
  \u00DC: "U",
  \u00F9: "u",
  \u00FA: "u",
  \u00FB: "u",
  \u00FC: "u",
  \u00DD: "Y",
  \u00FD: "y",
  \u00FF: "y",
  \u00C6: "Ae",
  \u00E6: "ae",
  \u00DE: "Th",
  \u00FE: "th",
  \u00DF: "ss",
  \u0100: "A",
  \u0102: "A",
  \u0104: "A",
  \u0101: "a",
  \u0103: "a",
  \u0105: "a",
  \u0106: "C",
  \u0108: "C",
  \u010A: "C",
  \u010C: "C",
  \u0107: "c",
  \u0109: "c",
  \u010B: "c",
  \u010D: "c",
  \u010E: "D",
  \u0110: "D",
  \u010F: "d",
  \u0111: "d",
  \u0112: "E",
  \u0114: "E",
  \u0116: "E",
  \u0118: "E",
  \u011A: "E",
  \u0113: "e",
  \u0115: "e",
  \u0117: "e",
  \u0119: "e",
  \u011B: "e",
  \u011C: "G",
  \u011E: "G",
  \u0120: "G",
  \u0122: "G",
  \u011D: "g",
  \u011F: "g",
  \u0121: "g",
  \u0123: "g",
  \u0124: "H",
  \u0126: "H",
  \u0125: "h",
  \u0127: "h",
  \u0128: "I",
  \u012A: "I",
  \u012C: "I",
  \u012E: "I",
  \u0130: "I",
  \u0129: "i",
  \u012B: "i",
  \u012D: "i",
  \u012F: "i",
  \u0131: "i",
  \u0134: "J",
  \u0135: "j",
  \u0136: "K",
  \u0137: "k",
  \u0138: "k",
  \u0139: "L",
  \u013B: "L",
  \u013D: "L",
  \u013F: "L",
  \u0141: "L",
  \u013A: "l",
  \u013C: "l",
  \u013E: "l",
  \u0140: "l",
  \u0142: "l",
  \u0143: "N",
  \u0145: "N",
  \u0147: "N",
  \u014A: "N",
  \u0144: "n",
  \u0146: "n",
  \u0148: "n",
  \u014B: "n",
  \u014C: "O",
  \u014E: "O",
  \u0150: "O",
  \u014D: "o",
  \u014F: "o",
  \u0151: "o",
  \u0154: "R",
  \u0156: "R",
  \u0158: "R",
  \u0155: "r",
  \u0157: "r",
  \u0159: "r",
  \u015A: "S",
  \u015C: "S",
  \u015E: "S",
  \u0160: "S",
  \u015B: "s",
  \u015D: "s",
  \u015F: "s",
  \u0161: "s",
  \u0162: "T",
  \u0164: "T",
  \u0166: "T",
  \u0163: "t",
  \u0165: "t",
  \u0167: "t",
  \u0168: "U",
  \u016A: "U",
  \u016C: "U",
  \u016E: "U",
  \u0170: "U",
  \u0172: "U",
  \u0169: "u",
  \u016B: "u",
  \u016D: "u",
  \u016F: "u",
  \u0171: "u",
  \u0173: "u",
  \u0174: "W",
  \u0175: "w",
  \u0176: "Y",
  \u0177: "y",
  \u0178: "Y",
  \u0179: "Z",
  \u017B: "Z",
  \u017D: "Z",
  \u017A: "z",
  \u017C: "z",
  \u017E: "z",
  \u0132: "IJ",
  \u0133: "ij",
  \u0152: "Oe",
  \u0153: "oe",
  \u0149: "'n",
  \u017F: "s"
}, Rr = Cr(Ir), Lr = Rr, Mr = typeof H == "object" && H && H.Object === Object && H, Ot = Mr, Dr = Ot, jr = typeof self == "object" && self && self.Object === Object && self, Nr = Dr || jr || Function("return this")(), y = Nr, Ur = y, Gr = Ur.Symbol, W = Gr;
function kr(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Hr = kr, Br = Array.isArray, x = Br, Ne = W, wt = Object.prototype, Fr = wt.hasOwnProperty, Kr = wt.toString, D = Ne ? Ne.toStringTag : void 0;
function qr(e) {
  var t = Fr.call(e, D), r = e[D];
  try {
    e[D] = void 0;
    var n = !0;
  } catch {
  }
  var a = Kr.call(e);
  return n && (t ? e[D] = r : delete e[D]), a;
}
var zr = qr, Wr = Object.prototype, Yr = Wr.toString;
function Zr(e) {
  return Yr.call(e);
}
var Vr = Zr, Ue = W, Jr = zr, Xr = Vr, Qr = "[object Null]", en = "[object Undefined]", Ge = Ue ? Ue.toStringTag : void 0;
function tn(e) {
  return e == null ? e === void 0 ? en : Qr : Ge && Ge in Object(e) ? Jr(e) : Xr(e);
}
var N = tn;
function rn(e) {
  return e != null && typeof e == "object";
}
var U = rn, nn = N, an = U, sn = "[object Symbol]";
function on(e) {
  return typeof e == "symbol" || an(e) && nn(e) == sn;
}
var Se = on, ke = W, un = Hr, fn = x, cn = Se, pn = 1 / 0, He = ke ? ke.prototype : void 0, Be = He ? He.toString : void 0;
function Pt(e) {
  if (typeof e == "string")
    return e;
  if (fn(e))
    return un(e, Pt) + "";
  if (cn(e))
    return Be ? Be.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -pn ? "-0" : t;
}
var ln = Pt, hn = ln;
function _n(e) {
  return e == null ? "" : hn(e);
}
var me = _n, dn = Lr, vn = me, gn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, yn = "\\u0300-\\u036f", bn = "\\ufe20-\\ufe2f", $n = "\\u20d0-\\u20ff", Sn = yn + bn + $n, mn = "[" + Sn + "]", xn = RegExp(mn, "g");
function An(e) {
  return e = vn(e), e && e.replace(gn, dn).replace(xn, "");
}
var Tn = An, En = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function On(e) {
  return e.match(En) || [];
}
var wn = On, Pn = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Cn(e) {
  return Pn.test(e);
}
var In = Cn, Ct = "\\ud800-\\udfff", Rn = "\\u0300-\\u036f", Ln = "\\ufe20-\\ufe2f", Mn = "\\u20d0-\\u20ff", Dn = Rn + Ln + Mn, It = "\\u2700-\\u27bf", Rt = "a-z\\xdf-\\xf6\\xf8-\\xff", jn = "\\xac\\xb1\\xd7\\xf7", Nn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Un = "\\u2000-\\u206f", Gn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Lt = "A-Z\\xc0-\\xd6\\xd8-\\xde", kn = "\\ufe0e\\ufe0f", Mt = jn + Nn + Un + Gn, Dt = "['\u2019]", Fe = "[" + Mt + "]", Hn = "[" + Dn + "]", jt = "\\d+", Bn = "[" + It + "]", Nt = "[" + Rt + "]", Ut = "[^" + Ct + Mt + jt + It + Rt + Lt + "]", Fn = "\\ud83c[\\udffb-\\udfff]", Kn = "(?:" + Hn + "|" + Fn + ")", qn = "[^" + Ct + "]", Gt = "(?:\\ud83c[\\udde6-\\uddff]){2}", kt = "[\\ud800-\\udbff][\\udc00-\\udfff]", w = "[" + Lt + "]", zn = "\\u200d", Ke = "(?:" + Nt + "|" + Ut + ")", Wn = "(?:" + w + "|" + Ut + ")", qe = "(?:" + Dt + "(?:d|ll|m|re|s|t|ve))?", ze = "(?:" + Dt + "(?:D|LL|M|RE|S|T|VE))?", Ht = Kn + "?", Bt = "[" + kn + "]?", Yn = "(?:" + zn + "(?:" + [qn, Gt, kt].join("|") + ")" + Bt + Ht + ")*", Zn = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Vn = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Jn = Bt + Ht + Yn, Xn = "(?:" + [Bn, Gt, kt].join("|") + ")" + Jn, Qn = RegExp([
  w + "?" + Nt + "+" + qe + "(?=" + [Fe, w, "$"].join("|") + ")",
  Wn + "+" + ze + "(?=" + [Fe, w + Ke, "$"].join("|") + ")",
  w + "?" + Ke + "+" + qe,
  w + "+" + ze,
  Vn,
  Zn,
  jt,
  Xn
].join("|"), "g");
function ea(e) {
  return e.match(Qn) || [];
}
var ta = ea, ra = wn, na = In, aa = me, ia = ta;
function sa(e, t, r) {
  return e = aa(e), t = r ? void 0 : t, t === void 0 ? na(e) ? ia(e) : ra(e) : e.match(t) || [];
}
var oa = sa, ua = Or, fa = Tn, ca = oa, pa = "['\u2019]", la = RegExp(pa, "g");
function ha(e) {
  return function(t) {
    return ua(ca(fa(t).replace(la, "")), e, "");
  };
}
var _a = ha, da = _a, va = da(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), Ft = va;
function ga(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var xe = ga, ya = N, ba = xe, $a = "[object AsyncFunction]", Sa = "[object Function]", ma = "[object GeneratorFunction]", xa = "[object Proxy]";
function Aa(e) {
  if (!ba(e))
    return !1;
  var t = ya(e);
  return t == Sa || t == ma || t == $a || t == xa;
}
var Kt = Aa, Ta = y, Ea = Ta["__core-js_shared__"], Oa = Ea, re = Oa, We = function() {
  var e = /[^.]+$/.exec(re && re.keys && re.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function wa(e) {
  return !!We && We in e;
}
var Pa = wa, Ca = Function.prototype, Ia = Ca.toString;
function Ra(e) {
  if (e != null) {
    try {
      return Ia.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var qt = Ra, La = Kt, Ma = Pa, Da = xe, ja = qt, Na = /[\\^$.*+?()[\]{}|]/g, Ua = /^\[object .+?Constructor\]$/, Ga = Function.prototype, ka = Object.prototype, Ha = Ga.toString, Ba = ka.hasOwnProperty, Fa = RegExp(
  "^" + Ha.call(Ba).replace(Na, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ka(e) {
  if (!Da(e) || Ma(e))
    return !1;
  var t = La(e) ? Fa : Ua;
  return t.test(ja(e));
}
var qa = Ka;
function za(e, t) {
  return e == null ? void 0 : e[t];
}
var Wa = za, Ya = qa, Za = Wa;
function Va(e, t) {
  var r = Za(e, t);
  return Ya(r) ? r : void 0;
}
var O = Va, Ja = O, Xa = function() {
  try {
    var e = Ja(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Qa = Xa, Ye = Qa;
function ei(e, t, r) {
  t == "__proto__" && Ye ? Ye(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var ti = ei;
function ri(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), s = n(t), o = s.length; o--; ) {
      var f = s[e ? o : ++a];
      if (r(i[f], f, i) === !1)
        break;
    }
    return t;
  };
}
var ni = ri, ai = ni, ii = ai(), si = ii;
function oi(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var ui = oi, fi = N, ci = U, pi = "[object Arguments]";
function li(e) {
  return ci(e) && fi(e) == pi;
}
var hi = li, Ze = hi, _i = U, zt = Object.prototype, di = zt.hasOwnProperty, vi = zt.propertyIsEnumerable, gi = Ze(function() {
  return arguments;
}()) ? Ze : function(e) {
  return _i(e) && di.call(e, "callee") && !vi.call(e, "callee");
}, Wt = gi, K = { exports: {} };
function yi() {
  return !1;
}
var bi = yi;
(function(e, t) {
  var r = y, n = bi, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, s = i && i.exports === a, o = s ? r.Buffer : void 0, f = o ? o.isBuffer : void 0, c = f || n;
  e.exports = c;
})(K, K.exports);
var $i = 9007199254740991, Si = /^(?:0|[1-9]\d*)$/;
function mi(e, t) {
  var r = typeof e;
  return t = t == null ? $i : t, !!t && (r == "number" || r != "symbol" && Si.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Yt = mi, xi = 9007199254740991;
function Ai(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= xi;
}
var Ae = Ai, Ti = N, Ei = Ae, Oi = U, wi = "[object Arguments]", Pi = "[object Array]", Ci = "[object Boolean]", Ii = "[object Date]", Ri = "[object Error]", Li = "[object Function]", Mi = "[object Map]", Di = "[object Number]", ji = "[object Object]", Ni = "[object RegExp]", Ui = "[object Set]", Gi = "[object String]", ki = "[object WeakMap]", Hi = "[object ArrayBuffer]", Bi = "[object DataView]", Fi = "[object Float32Array]", Ki = "[object Float64Array]", qi = "[object Int8Array]", zi = "[object Int16Array]", Wi = "[object Int32Array]", Yi = "[object Uint8Array]", Zi = "[object Uint8ClampedArray]", Vi = "[object Uint16Array]", Ji = "[object Uint32Array]", _ = {};
_[Fi] = _[Ki] = _[qi] = _[zi] = _[Wi] = _[Yi] = _[Zi] = _[Vi] = _[Ji] = !0;
_[wi] = _[Pi] = _[Hi] = _[Ci] = _[Bi] = _[Ii] = _[Ri] = _[Li] = _[Mi] = _[Di] = _[ji] = _[Ni] = _[Ui] = _[Gi] = _[ki] = !1;
function Xi(e) {
  return Oi(e) && Ei(e.length) && !!_[Ti(e)];
}
var Qi = Xi;
function es(e) {
  return function(t) {
    return e(t);
  };
}
var ts = es, ce = { exports: {} };
(function(e, t) {
  var r = Ot, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, s = i && r.process, o = function() {
    try {
      var f = a && a.require && a.require("util").types;
      return f || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(ce, ce.exports);
var rs = Qi, ns = ts, Ve = ce.exports, Je = Ve && Ve.isTypedArray, as = Je ? ns(Je) : rs, Zt = as, is = ui, ss = Wt, os = x, us = K.exports, fs = Yt, cs = Zt, ps = Object.prototype, ls = ps.hasOwnProperty;
function hs(e, t) {
  var r = os(e), n = !r && ss(e), a = !r && !n && us(e), i = !r && !n && !a && cs(e), s = r || n || a || i, o = s ? is(e.length, String) : [], f = o.length;
  for (var c in e)
    (t || ls.call(e, c)) && !(s && (c == "length" || a && (c == "offset" || c == "parent") || i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || fs(c, f))) && o.push(c);
  return o;
}
var _s = hs, ds = Object.prototype;
function vs(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || ds;
  return e === r;
}
var gs = vs;
function ys(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var bs = ys, $s = bs, Ss = $s(Object.keys, Object), ms = Ss, xs = gs, As = ms, Ts = Object.prototype, Es = Ts.hasOwnProperty;
function Os(e) {
  if (!xs(e))
    return As(e);
  var t = [];
  for (var r in Object(e))
    Es.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var ws = Os, Ps = Kt, Cs = Ae;
function Is(e) {
  return e != null && Cs(e.length) && !Ps(e);
}
var Rs = Is, Ls = _s, Ms = ws, Ds = Rs;
function js(e) {
  return Ds(e) ? Ls(e) : Ms(e);
}
var Te = js, Ns = si, Us = Te;
function Gs(e, t) {
  return e && Ns(e, t, Us);
}
var ks = Gs;
function Hs() {
  this.__data__ = [], this.size = 0;
}
var Bs = Hs;
function Fs(e, t) {
  return e === t || e !== e && t !== t;
}
var Vt = Fs, Ks = Vt;
function qs(e, t) {
  for (var r = e.length; r--; )
    if (Ks(e[r][0], t))
      return r;
  return -1;
}
var Y = qs, zs = Y, Ws = Array.prototype, Ys = Ws.splice;
function Zs(e) {
  var t = this.__data__, r = zs(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Ys.call(t, r, 1), --this.size, !0;
}
var Vs = Zs, Js = Y;
function Xs(e) {
  var t = this.__data__, r = Js(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Qs = Xs, eo = Y;
function to(e) {
  return eo(this.__data__, e) > -1;
}
var ro = to, no = Y;
function ao(e, t) {
  var r = this.__data__, n = no(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var io = ao, so = Bs, oo = Vs, uo = Qs, fo = ro, co = io;
function C(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
C.prototype.clear = so;
C.prototype.delete = oo;
C.prototype.get = uo;
C.prototype.has = fo;
C.prototype.set = co;
var Z = C, po = Z;
function lo() {
  this.__data__ = new po(), this.size = 0;
}
var ho = lo;
function _o(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var vo = _o;
function go(e) {
  return this.__data__.get(e);
}
var yo = go;
function bo(e) {
  return this.__data__.has(e);
}
var $o = bo, So = O, mo = y, xo = So(mo, "Map"), Ee = xo, Ao = O, To = Ao(Object, "create"), V = To, Xe = V;
function Eo() {
  this.__data__ = Xe ? Xe(null) : {}, this.size = 0;
}
var Oo = Eo;
function wo(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Po = wo, Co = V, Io = "__lodash_hash_undefined__", Ro = Object.prototype, Lo = Ro.hasOwnProperty;
function Mo(e) {
  var t = this.__data__;
  if (Co) {
    var r = t[e];
    return r === Io ? void 0 : r;
  }
  return Lo.call(t, e) ? t[e] : void 0;
}
var Do = Mo, jo = V, No = Object.prototype, Uo = No.hasOwnProperty;
function Go(e) {
  var t = this.__data__;
  return jo ? t[e] !== void 0 : Uo.call(t, e);
}
var ko = Go, Ho = V, Bo = "__lodash_hash_undefined__";
function Fo(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ho && t === void 0 ? Bo : t, this;
}
var Ko = Fo, qo = Oo, zo = Po, Wo = Do, Yo = ko, Zo = Ko;
function I(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
I.prototype.clear = qo;
I.prototype.delete = zo;
I.prototype.get = Wo;
I.prototype.has = Yo;
I.prototype.set = Zo;
var Vo = I, Qe = Vo, Jo = Z, Xo = Ee;
function Qo() {
  this.size = 0, this.__data__ = {
    hash: new Qe(),
    map: new (Xo || Jo)(),
    string: new Qe()
  };
}
var eu = Qo;
function tu(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var ru = tu, nu = ru;
function au(e, t) {
  var r = e.__data__;
  return nu(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var J = au, iu = J;
function su(e) {
  var t = iu(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var ou = su, uu = J;
function fu(e) {
  return uu(this, e).get(e);
}
var cu = fu, pu = J;
function lu(e) {
  return pu(this, e).has(e);
}
var hu = lu, _u = J;
function du(e, t) {
  var r = _u(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var vu = du, gu = eu, yu = ou, bu = cu, $u = hu, Su = vu;
function R(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
R.prototype.clear = gu;
R.prototype.delete = yu;
R.prototype.get = bu;
R.prototype.has = $u;
R.prototype.set = Su;
var Oe = R, mu = Z, xu = Ee, Au = Oe, Tu = 200;
function Eu(e, t) {
  var r = this.__data__;
  if (r instanceof mu) {
    var n = r.__data__;
    if (!xu || n.length < Tu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Au(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Ou = Eu, wu = Z, Pu = ho, Cu = vo, Iu = yo, Ru = $o, Lu = Ou;
function L(e) {
  var t = this.__data__ = new wu(e);
  this.size = t.size;
}
L.prototype.clear = Pu;
L.prototype.delete = Cu;
L.prototype.get = Iu;
L.prototype.has = Ru;
L.prototype.set = Lu;
var Jt = L, Mu = "__lodash_hash_undefined__";
function Du(e) {
  return this.__data__.set(e, Mu), this;
}
var ju = Du;
function Nu(e) {
  return this.__data__.has(e);
}
var Uu = Nu, Gu = Oe, ku = ju, Hu = Uu;
function q(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Gu(); ++t < r; )
    this.add(e[t]);
}
q.prototype.add = q.prototype.push = ku;
q.prototype.has = Hu;
var Bu = q;
function Fu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Ku = Fu;
function qu(e, t) {
  return e.has(t);
}
var zu = qu, Wu = Bu, Yu = Ku, Zu = zu, Vu = 1, Ju = 2;
function Xu(e, t, r, n, a, i) {
  var s = r & Vu, o = e.length, f = t.length;
  if (o != f && !(s && f > o))
    return !1;
  var c = i.get(e), p = i.get(t);
  if (c && p)
    return c == t && p == e;
  var l = -1, h = !0, d = r & Ju ? new Wu() : void 0;
  for (i.set(e, t), i.set(t, e); ++l < o; ) {
    var v = e[l], g = t[l];
    if (n)
      var b = s ? n(g, v, l, t, e, i) : n(v, g, l, e, t, i);
    if (b !== void 0) {
      if (b)
        continue;
      h = !1;
      break;
    }
    if (d) {
      if (!Yu(t, function(A, T) {
        if (!Zu(d, T) && (v === A || a(v, A, r, n, i)))
          return d.push(T);
      })) {
        h = !1;
        break;
      }
    } else if (!(v === g || a(v, g, r, n, i))) {
      h = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), h;
}
var Xt = Xu, Qu = y, ef = Qu.Uint8Array, tf = ef;
function rf(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var nf = rf;
function af(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var sf = af, et = W, tt = tf, of = Vt, uf = Xt, ff = nf, cf = sf, pf = 1, lf = 2, hf = "[object Boolean]", _f = "[object Date]", df = "[object Error]", vf = "[object Map]", gf = "[object Number]", yf = "[object RegExp]", bf = "[object Set]", $f = "[object String]", Sf = "[object Symbol]", mf = "[object ArrayBuffer]", xf = "[object DataView]", rt = et ? et.prototype : void 0, ne = rt ? rt.valueOf : void 0;
function Af(e, t, r, n, a, i, s) {
  switch (r) {
    case xf:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mf:
      return !(e.byteLength != t.byteLength || !i(new tt(e), new tt(t)));
    case hf:
    case _f:
    case gf:
      return of(+e, +t);
    case df:
      return e.name == t.name && e.message == t.message;
    case yf:
    case $f:
      return e == t + "";
    case vf:
      var o = ff;
    case bf:
      var f = n & pf;
      if (o || (o = cf), e.size != t.size && !f)
        return !1;
      var c = s.get(e);
      if (c)
        return c == t;
      n |= lf, s.set(e, t);
      var p = uf(o(e), o(t), n, a, i, s);
      return s.delete(e), p;
    case Sf:
      if (ne)
        return ne.call(e) == ne.call(t);
  }
  return !1;
}
var Tf = Af;
function Ef(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Of = Ef, wf = Of, Pf = x;
function Cf(e, t, r) {
  var n = t(e);
  return Pf(e) ? n : wf(n, r(e));
}
var If = Cf;
function Rf(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (i[a++] = s);
  }
  return i;
}
var Lf = Rf;
function Mf() {
  return [];
}
var Df = Mf, jf = Lf, Nf = Df, Uf = Object.prototype, Gf = Uf.propertyIsEnumerable, nt = Object.getOwnPropertySymbols, kf = nt ? function(e) {
  return e == null ? [] : (e = Object(e), jf(nt(e), function(t) {
    return Gf.call(e, t);
  }));
} : Nf, Hf = kf, Bf = If, Ff = Hf, Kf = Te;
function qf(e) {
  return Bf(e, Kf, Ff);
}
var zf = qf, at = zf, Wf = 1, Yf = Object.prototype, Zf = Yf.hasOwnProperty;
function Vf(e, t, r, n, a, i) {
  var s = r & Wf, o = at(e), f = o.length, c = at(t), p = c.length;
  if (f != p && !s)
    return !1;
  for (var l = f; l--; ) {
    var h = o[l];
    if (!(s ? h in t : Zf.call(t, h)))
      return !1;
  }
  var d = i.get(e), v = i.get(t);
  if (d && v)
    return d == t && v == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var b = s; ++l < f; ) {
    h = o[l];
    var A = e[h], T = t[h];
    if (n)
      var Ce = s ? n(T, A, h, t, e, i) : n(A, T, h, e, t, i);
    if (!(Ce === void 0 ? A === T || a(A, T, r, n, i) : Ce)) {
      g = !1;
      break;
    }
    b || (b = h == "constructor");
  }
  if (g && !b) {
    var G = e.constructor, k = t.constructor;
    G != k && "constructor" in e && "constructor" in t && !(typeof G == "function" && G instanceof G && typeof k == "function" && k instanceof k) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var Jf = Vf, Xf = O, Qf = y, ec = Xf(Qf, "DataView"), tc = ec, rc = O, nc = y, ac = rc(nc, "Promise"), ic = ac, sc = O, oc = y, uc = sc(oc, "Set"), fc = uc, cc = O, pc = y, lc = cc(pc, "WeakMap"), hc = lc, pe = tc, le = Ee, he = ic, _e = fc, de = hc, Qt = N, M = qt, it = "[object Map]", _c = "[object Object]", st = "[object Promise]", ot = "[object Set]", ut = "[object WeakMap]", ft = "[object DataView]", dc = M(pe), vc = M(le), gc = M(he), yc = M(_e), bc = M(de), E = Qt;
(pe && E(new pe(new ArrayBuffer(1))) != ft || le && E(new le()) != it || he && E(he.resolve()) != st || _e && E(new _e()) != ot || de && E(new de()) != ut) && (E = function(e) {
  var t = Qt(e), r = t == _c ? e.constructor : void 0, n = r ? M(r) : "";
  if (n)
    switch (n) {
      case dc:
        return ft;
      case vc:
        return it;
      case gc:
        return st;
      case yc:
        return ot;
      case bc:
        return ut;
    }
  return t;
});
var $c = E, ae = Jt, Sc = Xt, mc = Tf, xc = Jf, ct = $c, pt = x, lt = K.exports, Ac = Zt, Tc = 1, ht = "[object Arguments]", _t = "[object Array]", B = "[object Object]", Ec = Object.prototype, dt = Ec.hasOwnProperty;
function Oc(e, t, r, n, a, i) {
  var s = pt(e), o = pt(t), f = s ? _t : ct(e), c = o ? _t : ct(t);
  f = f == ht ? B : f, c = c == ht ? B : c;
  var p = f == B, l = c == B, h = f == c;
  if (h && lt(e)) {
    if (!lt(t))
      return !1;
    s = !0, p = !1;
  }
  if (h && !p)
    return i || (i = new ae()), s || Ac(e) ? Sc(e, t, r, n, a, i) : mc(e, t, f, r, n, a, i);
  if (!(r & Tc)) {
    var d = p && dt.call(e, "__wrapped__"), v = l && dt.call(t, "__wrapped__");
    if (d || v) {
      var g = d ? e.value() : e, b = v ? t.value() : t;
      return i || (i = new ae()), a(g, b, r, n, i);
    }
  }
  return h ? (i || (i = new ae()), xc(e, t, r, n, a, i)) : !1;
}
var wc = Oc, Pc = wc, vt = U;
function er(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !vt(e) && !vt(t) ? e !== e && t !== t : Pc(e, t, r, n, er, a);
}
var tr = er, Cc = Jt, Ic = tr, Rc = 1, Lc = 2;
function Mc(e, t, r, n) {
  var a = r.length, i = a, s = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var o = r[a];
    if (s && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    o = r[a];
    var f = o[0], c = e[f], p = o[1];
    if (s && o[2]) {
      if (c === void 0 && !(f in e))
        return !1;
    } else {
      var l = new Cc();
      if (n)
        var h = n(c, p, f, e, t, l);
      if (!(h === void 0 ? Ic(p, c, Rc | Lc, n, l) : h))
        return !1;
    }
  }
  return !0;
}
var Dc = Mc, jc = xe;
function Nc(e) {
  return e === e && !jc(e);
}
var rr = Nc, Uc = rr, Gc = Te;
function kc(e) {
  for (var t = Gc(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, Uc(a)];
  }
  return t;
}
var Hc = kc;
function Bc(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var nr = Bc, Fc = Dc, Kc = Hc, qc = nr;
function zc(e) {
  var t = Kc(e);
  return t.length == 1 && t[0][2] ? qc(t[0][0], t[0][1]) : function(r) {
    return r === e || Fc(r, e, t);
  };
}
var Wc = zc, Yc = x, Zc = Se, Vc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Jc = /^\w*$/;
function Xc(e, t) {
  if (Yc(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Zc(e) ? !0 : Jc.test(e) || !Vc.test(e) || t != null && e in Object(t);
}
var we = Xc, ar = Oe, Qc = "Expected a function";
function Pe(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Qc);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var s = e.apply(this, n);
    return r.cache = i.set(a, s) || i, s;
  };
  return r.cache = new (Pe.Cache || ar)(), r;
}
Pe.Cache = ar;
var ep = Pe, tp = ep, rp = 500;
function np(e) {
  var t = tp(e, function(n) {
    return r.size === rp && r.clear(), n;
  }), r = t.cache;
  return t;
}
var ap = np, ip = ap, sp = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, op = /\\(\\)?/g, up = ip(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(sp, function(r, n, a, i) {
    t.push(a ? i.replace(op, "$1") : n || r);
  }), t;
}), fp = up, cp = x, pp = we, lp = fp, hp = me;
function _p(e, t) {
  return cp(e) ? e : pp(e, t) ? [e] : lp(hp(e));
}
var ir = _p, dp = Se, vp = 1 / 0;
function gp(e) {
  if (typeof e == "string" || dp(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -vp ? "-0" : t;
}
var X = gp, yp = ir, bp = X;
function $p(e, t) {
  t = yp(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[bp(t[r++])];
  return r && r == n ? e : void 0;
}
var sr = $p, Sp = sr;
function mp(e, t, r) {
  var n = e == null ? void 0 : Sp(e, t);
  return n === void 0 ? r : n;
}
var xp = mp;
function Ap(e, t) {
  return e != null && t in Object(e);
}
var Tp = Ap, Ep = ir, Op = Wt, wp = x, Pp = Yt, Cp = Ae, Ip = X;
function Rp(e, t, r) {
  t = Ep(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var s = Ip(t[n]);
    if (!(i = e != null && r(e, s)))
      break;
    e = e[s];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && Cp(a) && Pp(s, a) && (wp(e) || Op(e)));
}
var Lp = Rp, Mp = Tp, Dp = Lp;
function jp(e, t) {
  return e != null && Dp(e, t, Mp);
}
var Np = jp, Up = tr, Gp = xp, kp = Np, Hp = we, Bp = rr, Fp = nr, Kp = X, qp = 1, zp = 2;
function Wp(e, t) {
  return Hp(e) && Bp(t) ? Fp(Kp(e), t) : function(r) {
    var n = Gp(r, e);
    return n === void 0 && n === t ? kp(r, e) : Up(t, n, qp | zp);
  };
}
var Yp = Wp;
function Zp(e) {
  return e;
}
var Vp = Zp;
function Jp(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Xp = Jp, Qp = sr;
function el(e) {
  return function(t) {
    return Qp(t, e);
  };
}
var tl = el, rl = Xp, nl = tl, al = we, il = X;
function sl(e) {
  return al(e) ? rl(il(e)) : nl(e);
}
var ol = sl, ul = Wc, fl = Yp, cl = Vp, pl = x, ll = ol;
function hl(e) {
  return typeof e == "function" ? e : e == null ? cl : typeof e == "object" ? pl(e) ? fl(e[0], e[1]) : ul(e) : ll(e);
}
var _l = hl, dl = ti, vl = ks, gl = _l;
function yl(e, t) {
  var r = {};
  return t = gl(t), vl(e, function(n, a, i) {
    dl(r, t(n, a, i), n);
  }), r;
}
var bl = yl, P;
(function(e) {
  e.CLICK = "click", e.PAGEVIEW = "pageview", e.MODAL_VIEW = "modal-view", e.DEPTH = "depth", e.ERROR = "error", e.API = "api", e.EXPERIMENT = "experiment", e.ENTRY = "entry", e.SINGLE_PAGE_FLOW = "single-page-flow";
})(P || (P = {}));
class wl {
  constructor(t, r = []) {
    this.appName = t, this.externalSDKs = r;
  }
  identify(t, r) {
    this.externalSDKs.forEach((n) => {
      var a;
      try {
        (a = n()) == null || a.identify(t, r);
      } catch (i) {
        te((s) => {
          s.setExtra("analytics-client", "Error identifying user"), ee(i);
        });
      }
    });
  }
  track(t, r, n = {}) {
    this.externalSDKs.forEach((a) => {
      var i;
      try {
        (i = a()) == null || i.track(r, {
          event_title: t,
          event_type: r,
          app: this.appName,
          ...bl(n, (s, o) => Ft(o))
        });
      } catch (s) {
        te((o) => {
          o.setExtra("analytics-client", "Error tracking event"), ee(s);
        });
      }
    });
  }
  trackEvent({ eventName: t, eventType: r, eventProperties: n }) {
    this.track(t, r, n);
  }
  trackClick(t, r) {
    this.track(t, P.CLICK, r);
  }
  trackModalView(t, r) {
    this.track(t, P.MODAL_VIEW, r);
  }
  trackSinglePageFlow(t, r) {
    this.track(t, P.SINGLE_PAGE_FLOW, r);
  }
  reset() {
    this.externalSDKs.forEach((t) => {
      var r, n;
      try {
        (n = (r = t()) == null ? void 0 : r.reset) == null || n.call(r);
      } catch (a) {
        te((i) => {
          i.setExtra("analytics-client", "Error reseting session"), ee(a);
        });
      }
    });
  }
}
function $l(e, t) {
  function r() {
    const n = e(), a = yt(t);
    return or(() => {
      function i({ eventName: p, eventType: l, eventProperties: h = {} }) {
        n.trackEvent({
          eventName: p,
          eventType: l,
          eventProperties: {
            ...a,
            ...h
          }
        });
      }
      function s(p, l, h = {}) {
        n.track(p, l, {
          ...a,
          ...h
        });
      }
      function o(p, l = {}) {
        n.trackClick(p, {
          ...a,
          ...l
        });
      }
      function f(p, l = {}) {
        n.trackModalView(p, {
          ...a,
          ...l
        });
      }
      function c(p, l = {}) {
        n.trackSinglePageFlow(p, {
          ...a,
          ...l
        });
      }
      return {
        EventType: P,
        trackEvent: i,
        track: s,
        trackClick: o,
        trackModalView: f,
        trackSinglePageFlow: c
      };
    }, [n, a]);
  }
  return r;
}
function Sl(e) {
  return function() {
    const r = yt(e);
    if (!r)
      throw new Error("Couldn't find an AnalyticsClient. Are you sure you configured an AnalyticsProvider with one?");
    return r;
  };
}
function ml(e) {
  return bt(e);
}
function xl() {
  const e = bt(null);
  return {
    AnalyticsClientContext: e,
    AnalyticsProvider: ({
      analyticsClient: r,
      children: n
    }) => ur(e.Provider, {
      value: r,
      children: n
    })
  };
}
function Pl() {
  const e = ml({}), { AnalyticsProvider: t, AnalyticsClientContext: r } = xl(), n = Sl(r), a = $l(n, e);
  return {
    AnalyticsPageContext: e,
    AnalyticsProvider: t,
    AnalyticsClientContext: r,
    useAnalyticsClient: n,
    useAnalytics: a
  };
}
const gt = ["uuid", "id", "slug"];
function Al(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
const ie = (e) => Ft(e);
function Tl(e, t = []) {
  return Object.entries(e).reduce((r, [n, a]) => {
    if (t.includes(n))
      return {
        ...r,
        [ie(n)]: "**redacted**"
      };
    let i = n, s = a;
    if (a !== null && typeof a == "object")
      for (let o = 0; o < gt.length; o++) {
        const f = gt[o];
        if (Al(a, f)) {
          i = `${n}_${f}`, s = a[f];
          break;
        }
      }
    return s == null || typeof s == "string" || typeof s == "number" || typeof s == "boolean" || s instanceof Date ? { ...r, [ie(i)]: s } : {
      ...r,
      [ie(i)]: `[${typeof s}]`
    };
  }, {});
}
const Cl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertToSafeParams: Tl
}, Symbol.toStringTag, { value: "Module" }));
export {
  wl as AnalyticsClient,
  P as AnalyticsEventType,
  Cl as PropertyUtils,
  ml as createAnalyticsPageContext,
  xl as createAnalyticsProvider,
  Pl as createAnalyticsReactModule,
  $l as createUseAnalytics,
  Sl as createUseAnalyticsClient
};
//# sourceMappingURL=analytics-core.es.js.map
